var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dashboard-container p-20 position-relative" },
    [
      _c("div", { staticClass: "container-responsive" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("carousel-widget", { attrs: { isDefault: _vm.isDefault } }),
            _vm.topService && _vm.remainingServices
              ? _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-4 col-lg-4 marketplace-right",
                  },
                  [
                    _c("div", { staticClass: "marketing-widget" }, [
                      _c("div", { staticClass: "starting-marketplace" }, [
                        _vm._m(0),
                        _c("div", { staticClass: "market-place-line p-0" }, [
                          _c("img", {
                            staticClass: "laptop-image",
                            attrs: { src: _vm.topService.image_location },
                          }),
                        ]),
                        _c(
                          "div",
                          { staticClass: "marketplace-smart-builder" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "smart-builder market-place-line d-flex p-0",
                              },
                              [
                                _c("span", [
                                  _c("div", { staticClass: "d-flex" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-9 col-sm-9 col-md-9 col-lg-9 mr_tp_10 p-0 countries_select_list",
                                      },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "country-label" },
                                          [_vm._v("Country")]
                                        ),
                                        _c(
                                          "multiselect",
                                          {
                                            staticClass:
                                              "multiselect-single-dropdown",
                                            attrs: {
                                              showLabels: false,
                                              "close-on-select": true,
                                              "allow-empty": false,
                                              searchable: true,
                                              options:
                                                _vm.countriesData.countries.map(
                                                  (country) =>
                                                    country.country_name
                                                ),
                                              placeholder: "Select",
                                            },
                                            on: { input: _vm.countrySelected },
                                            model: {
                                              value: _vm.country,
                                              callback: function ($$v) {
                                                _vm.country = $$v
                                              },
                                              expression: "country",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "noResult" },
                                                slot: "noResult",
                                              },
                                              [_vm._v("No matching data")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-2 col-sm-2 col-md-2 mr_tp_10 margin_left",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn emergo-green-button button_go",
                                            on: {
                                              click: function ($event) {
                                                _vm.country !== ""
                                                  ? _vm.redirect(
                                                      `/layout/resourcesdashboard`,
                                                      _vm.country
                                                    )
                                                  : null
                                              },
                                            },
                                          },
                                          [_vm._v(" GO ")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "pt-12" }, [
                                    _c(
                                      "div",
                                      { staticClass: "sub-doc d-flex" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.topService.description)
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ]),
                                ]),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "last-marketplace market-place-line p-0",
                        },
                        [
                          _c("div", { staticClass: "premium-services" }, [
                            _vm._v("Premium Services"),
                          ]),
                          _vm._l(_vm.remainingServices, function (service) {
                            return _c(
                              "div",
                              {
                                key: service.id,
                                staticClass: "main-reg-intel d-flex",
                              },
                              [
                                _c("img", {
                                  staticClass: "market-img",
                                  class: { "market-img-gg": service.id == 5 },
                                  attrs: {
                                    src: _vm.getImageUrl(
                                      service.icon_location,
                                      true
                                    ),
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "premium-regulatory" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "sub-category",
                                        on: {
                                          click: function ($event) {
                                            return _vm.redirect(
                                              `/layout/market-place/service/${service.id}`
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(service.name) + " ")]
                                    ),
                                    _c("div", { staticClass: "pt-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "sub-premium" },
                                        [_vm._v(_vm._s(service.description))]
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "see-more marketplace-see-more",
                          on: {
                            click: function ($event) {
                              return _vm.redirect(`/layout/market-place`)
                            },
                          },
                        },
                        [_vm._v("Learn more")]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-8" },
              [
                _c("div", { staticClass: "notification-widget" }, [
                  _c(
                    "div",
                    { staticClass: "widget-card noti-ht" },
                    [
                      _vm._m(1),
                      _vm._l(
                        _vm.notificationsList,
                        function (notificationsPerDate, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "each-notification mt-10",
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-xs-5 col-sm-4 col-md-4 col-lg-5 notification-date-css",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatDate")(
                                            notificationsPerDate.date,
                                            "DD-MM-YYYY",
                                            "MMM DD, YYYY"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._l(
                                notificationsPerDate.notifications,
                                function (notification, index) {
                                  return _c("div", { key: index }, [
                                    _c("div", { staticClass: "pl-14 pt-10" }, [
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row notification_text_block d-flex align-items-start",
                                          },
                                          [
                                            notification.type == "RW" ||
                                            notification.type == "UN"
                                              ? _c("div", [
                                                  _c("span", {
                                                    staticClass:
                                                      "flag-icon flag-icon-squared mr-12",
                                                    class: notification.icon,
                                                  }),
                                                ])
                                              : notification.type == "SB"
                                              ? _c("img", {
                                                  staticClass: "mr-12 img-size",
                                                  attrs: {
                                                    src: "/static/images/icons/track_plus_icon_blue.svg",
                                                    alt: "",
                                                  },
                                                })
                                              : notification.type == "PC"
                                              ? _c("img", {
                                                  staticClass: "mr-12 img-size",
                                                  attrs: {
                                                    src: "/static/images/icons/prod_classification_blue.svg",
                                                    alt: "",
                                                  },
                                                })
                                              : notification.type == "RP"
                                              ? _c("img", {
                                                  staticClass: "mr-12 img-size",
                                                  attrs: {
                                                    src: "/static/images/icons/reg_pathway_blue.svg",
                                                    alt: "",
                                                  },
                                                })
                                              : _c("img", {
                                                  staticClass: "mr-12 img-size",
                                                  attrs: {
                                                    src: "/static/images/icons/smartexchange_icon_blue.svg",
                                                    alt: "",
                                                  },
                                                }),
                                            notification.type == "RW"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "notification-details",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "New Regulatory update has been published for " +
                                                        _vm._s(
                                                          notification.country_name
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : notification.type == "UN" ||
                                                notification.type == "SX" ||
                                                notification.type == "PC" ||
                                                notification.type == "RP"
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "notification-details",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(notification.title)
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [
                                                  notification.notification_type ==
                                                  "Project"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "notification-details",
                                                        },
                                                        [
                                                          notification.project_action_type ==
                                                          "Export"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    notification.project_title
                                                                  ) + " "
                                                                ),
                                                                notification.project_status ==
                                                                "Success"
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        "has been exported "
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                notification.project_status ==
                                                                "Fail"
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        "export failed"
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ])
                                                            : _vm._e(),
                                                          notification.project_action_type ==
                                                          "Complete"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "The " +
                                                                    _vm._s(
                                                                      notification.project_title
                                                                    ) +
                                                                    " "
                                                                ),
                                                                notification.project_status ==
                                                                "Success"
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        "is 100% complete"
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                                notification.project_status ==
                                                                "Fail"
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        "is not completed"
                                                                      ),
                                                                    ])
                                                                  : _vm._e(),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  notification.notification_type ==
                                                  "User Comment"
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "notification-details",
                                                        },
                                                        [
                                                          notification.comment_type ==
                                                          "Commented"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  "You have been mentioned in " +
                                                                    _vm._s(
                                                                      notification.project_title
                                                                    )
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                          notification.comment_type ==
                                                          "Replied"
                                                            ? _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    notification.commentator_name
                                                                  ) +
                                                                    " have been mentioned in " +
                                                                    _vm._s(
                                                                      notification.project_title
                                                                    )
                                                                ),
                                                              ])
                                                            : _vm._e(),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]),
                                          ]
                                        ),
                                      ]),
                                    ]),
                                  ])
                                }
                              ),
                            ],
                            2
                          )
                        }
                      ),
                      _c("div", { staticClass: "footer" }, [
                        _c(
                          "span",
                          {
                            staticClass: "see-more",
                            on: {
                              click: function ($event) {
                                return _vm.redirect(`/layout/alert`)
                              },
                            },
                          },
                          [_vm._v("See All")]
                        ),
                      ]),
                    ],
                    2
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-8" },
              [
                _c("div", { staticClass: "upcoming-widget" }, [
                  _c("div", { staticClass: "widget-card position-relative" }, [
                    _c("div", { staticClass: "header d-flex" }, [
                      _c("img", {
                        attrs: {
                          src: "/static/images/icons/featured_content_icon.svg",
                        },
                      }),
                      _c("h3", { staticClass: "title m-0" }, [
                        _vm._v("Featured Content"),
                      ]),
                      _c("span", { staticClass: "admin-features" }, [
                        _vm.roleId === 5 || _vm.roleId === 7
                          ? _c(
                              "span",
                              [
                                _c(
                                  "span",
                                  {
                                    class:
                                      _vm.allFeaturedContent.length >= 12
                                        ? "cursor-pointer-disable"
                                        : "cursor-pointer",
                                    on: {
                                      click: function ($event) {
                                        _vm.allFeaturedContent.length >= 12
                                          ? ""
                                          : _vm.openAddPopup("Featured Content")
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticClass: "margin-icon",
                                      attrs: {
                                        src: "/static/images/icons/plus_icon_blue.svg",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "admin-features-label" },
                                      [_vm._v("Upload New")]
                                    ),
                                  ]
                                ),
                                _vm.featuredContent
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "featured-content-delete cursor-pointer",
                                        on: {
                                          click:
                                            _vm.deleteFeaturedContentHeadline,
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "margin-icon",
                                          attrs: {
                                            src: "/static/images/icons/delete_icon.svg",
                                          },
                                        }),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "admin-features-label delete",
                                          },
                                          [_vm._v("Delete")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.allFeaturedContent.length >= 12
                                  ? _c(
                                      "el-popover",
                                      {
                                        staticClass: "cursor-pointer",
                                        attrs: {
                                          placement: "bottom-end",
                                          trigger: "click",
                                          width: "350",
                                        },
                                        on: {
                                          show: function ($event) {
                                            _vm.infoActive = true
                                          },
                                          hide: function ($event) {
                                            _vm.infoActive = false
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "limit_popover_txt word-break text-start",
                                          },
                                          [
                                            _vm._v(
                                              " Max limit of 12 FC entries. Please delete past entries. "
                                            ),
                                          ]
                                        ),
                                        !_vm.infoActive
                                          ? _c("img", {
                                              staticClass: "info-img",
                                              attrs: {
                                                slot: "reference",
                                                src: "/static/images/icons/info_icon.svg",
                                              },
                                              slot: "reference",
                                            })
                                          : _vm._e(),
                                        _vm.infoActive
                                          ? _c("img", {
                                              staticClass: "info-img",
                                              attrs: {
                                                slot: "reference",
                                                src: "/static/images/icons/info_icon_active.svg",
                                              },
                                              slot: "reference",
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ]),
                    _vm.featuredContent && _vm.windowWidth <= 600
                      ? _c("span", { staticClass: "date-title" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("UTCDate")(
                                  _vm.featuredContent.start_date,
                                  "LL"
                                )
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm.featuredContent
                      ? _c("div", { staticClass: "webinar-header" }, [
                          _c(
                            "div",
                            { staticClass: "card d-flex flex-row flex-wrap" },
                            [
                              _c("div", { staticClass: "card-header" }, [
                                _c("img", {
                                  staticClass: "webinar-card",
                                  attrs: {
                                    src: _vm.getImageUrl(
                                      _vm.featuredContent.image
                                    ),
                                    alt: "webinar-img",
                                  },
                                }),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "px-2 sub-content-header word-break",
                                },
                                [
                                  _vm.featuredContent && _vm.windowWidth > 600
                                    ? _c(
                                        "span",
                                        { staticClass: "date-title" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm._f("UTCDate")(
                                                  _vm.featuredContent
                                                    .start_date,
                                                  "LL"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "sub-content-1 text-emergo-dark-blue",
                                      class: {
                                        "url-hover":
                                          _vm.featuredContent.redirection_url,
                                      },
                                    },
                                    [
                                      !_vm.featuredContent.redirection_url
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: "javascript:void(0);",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.featuredContent.title
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm.featuredContent.redirection_url &&
                                          _vm.selfURL(
                                            _vm.featuredContent.redirection_url
                                          )
                                        ? _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: _vm.getPathFromURL(
                                                  _vm.featuredContent
                                                    .redirection_url
                                                ),
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.featuredContent.title
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm.featuredContent.redirection_url &&
                                          !_vm.selfURL(
                                            _vm.featuredContent.redirection_url
                                          )
                                        ? _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.featuredContent
                                                  .redirection_url,
                                                target: "_blank",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.featuredContent.title
                                                  )
                                                ),
                                              ]),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "sub-content-2" }, [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.featuredContent.description
                                        ),
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.featuredContent
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-12 col-md-12 col-sm-12 col-xs-12 plr-4 invalid-content",
                          },
                          [_vm._m(2)]
                        )
                      : _vm._e(),
                    (_vm.roleId === 5 || _vm.roleId === 7) &&
                    _vm.allFeaturedContent.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "featured-content-footer position-relative d-flex justify-content-end",
                            class: {
                              "remove-bottom": !_vm.allFeaturedContent.length,
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "cursor-pointer",
                                on: {
                                  click: function ($event) {
                                    return _vm.openEditPopup("Featured Content")
                                  },
                                },
                              },
                              [
                                _vm._v("   "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "admin-features-label see-all-label",
                                  },
                                  [_vm._v("See All")]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c("default-modal", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value:
              _vm.isDashboardNotification &&
              _vm.isDashboardNotification != null,
            expression:
              "isDashboardNotification && isDashboardNotification != null",
          },
        ],
        attrs: {
          defaultMessage: _vm.isDashboardNotification,
          isDashboardCustomizable: _vm.isDashboardCustomizable,
        },
      }),
      _c("delete-head-line-popup", {
        attrs: {
          selectedHeadlines: _vm.featuredContent
            ? [_vm.featuredContent.id]
            : [],
          headLineType: "featuredcontent",
        },
        on: { refreshHeadLinesList: _vm.getRegulatoryHeadlines },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "market-title d-flex" }, [
      _vm._v(" Explore RAMS "),
      _c("span", { staticClass: "new-image center" }, [_vm._v("NEW")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header d-flex align-items-center" }, [
      _c("img", {
        attrs: { src: "/static/images/icons/notification_blue.svg" },
      }),
      _c("h3", { staticClass: "title m-0" }, [_vm._v("Notifications")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sub-content-2 pb-20 pt-10 bt-20" }, [
      _c("span", [
        _vm._v(
          "We currently have no upcoming events, please follow us in this space."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }